<template>
  <div>
    <b-modal no-fade size="lg" id="modal-type" no-close-on-esc no-close-on-backdrop title="Tipo de Contrato">
      <b-row>
        <b-col lg="4">
          <b-form-group label="Código" label-size="sm" label-for="tipo_id">
            <b-form-input
              maxlength="10"
              size="sm"
              id="tipo_id"
              v-model="type.tipo_id"
              disabled
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="2">
          <b-form-group label="Ativo" label-size="sm" label-for="ind_ativo">
            <b-form-checkbox
              id="ind_ativo"
              v-model="type.ind_ativo"
              name="ind_ativo"
              value="1"
              :disabled="action === 'view'"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-form-group label="Descrição" label-size="sm" label-for="descricao">
            <b-form-input
              size="sm"
              id="descricao"
              maxlength="255"
              v-model="type.descricao"
              :disabled="action === 'view'"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <b-button v-if="action !== 'view'" size="sm" @click="saveRecord()" variant="primary">
          <i class="fas fa-check"></i> Gravar
        </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-type')">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";

export default {
  name: "ModalTipoContrato",
  props: {
    type: { type: Object, required: true },
    action: { type: String, required: true, default: "view" }
  },
  methods: {
    validateRecord() {
      let _msg = "";

      if ((this.type.descricao || "") === "") _msg = "Informe a Descrição";

      if (_msg !== "") {
        this.$toasted.info(_msg, {
          duration: 4000,
          keepOnHover: true,
          className: "v-toasted-warning"
        });
        return false;
      }
      return true;
    },
    saveRecord() {
      if (!this.validateRecord()) return;

      if (this.action === "new") {
        axios
          .post(`${baseApiUrl}/bid/tiposcontrato`, this.type)
          .then(() => {
            this.$bvModal.hide("modal-type");
            this.$emit("updated");
          })
          .catch(err => {
            showError(err);
          });
      } else {
        axios
          .put(`${baseApiUrl}/bid/tiposcontrato/${this.type.tipo_id}`, this.type)
          .then(() => {
            this.$bvModal.hide("modal-type");
            this.$emit("updated");
          })
          .catch(err => {
            showError(err);
          });
      }
    }
  }
};
</script>

<style>
</style>